import { render, staticRenderFns } from "./qualityRemarkItem.vue?vue&type=template&id=9e900f74&scoped=true&"
import script from "./qualityRemarkItem.vue?vue&type=script&lang=js&"
export * from "./qualityRemarkItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e900f74",
  null
  
)

export default component.exports